export default __webpack_public_path__ + "static/media/Ubuntu-Light.086e75a1.woff";